'use strict'
import { convertTime, formatDate, convertConfiguredTime } from '../../components/helpers.js'

export function showWarningOut (event) {
  // event.reason, event.startTime, event.endTime
  const now = (new Date()).getTime()
  let showWarningKicked = false
  let warningKickedMain = 'Сессия была принудительно завершена. \n'
  let warningKickedBan = null
  let warningKickedReason = ''
  if (event.type && event.type == 'user.kicked') {
    warningKickedReason = event.reason
    showWarningKicked = true
    if (event.endTime) {
      warningKickedBan = 'Вход в систему будет запрещён до ' + convertTime(event.endTime)
    }
  } else {
    if (event.kickSessionStartTime) {
      warningKickedReason = event.kickSessionReason
      if ((event.kickSessionStartTime < now) && event.sessionWereKicked) {
        showWarningKicked = true
      } else if (event.kickSessionStartTime && (event.kickSessionStartTime > now)) {
        showWarningKicked = ((event.kickSessionStartTime - now) / 60000) < 30
        const startDate = formatDate(event.kickSessionStartTime)
        const startTime = convertConfiguredTime(event.kickSessionStartTime, { year: false, month: false, date: false, hour: true, min: true, sec: false })
        let kickedTime = convertTime(event.kickSessionStartTime)
        if (event.kickSessionEndTime) {
          const endDate = formatDate(event.kickSessionEndTime)
          const endTime = convertConfiguredTime(event.kickSessionEndTime, { year: false, month: false, date: false, hour: true, min: true, sec: false })
          kickedTime = startDate == endDate ? (startDate + ' с ' + startTime + ' по ' + endTime) : (' с ' + convertTime(event.kickSessionStartTime) + ' по ' + convertTime(event.kickSessionEndTime))
        }
        warningKickedMain = 'Сессия будет принудительно завершена \n' + kickedTime
      }
    }
  }

  return { showWarningKicked: showWarningKicked, warningKickedMain: warningKickedMain, warningKickedBan: warningKickedBan, warningKickedReason: warningKickedReason }
}
